// extracted by mini-css-extract-plugin
export default {"root":"BackNavigation_root__pd9-H","arrow":"BackNavigation_arrow__8Mj2y"};